import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { checkDpSuccess, getFormErrorMessage } from '../../utility/service/tool-service';
import { queryCompaniesListByType } from '../../utility/service/company-service';

const AddCompany = ({control,errors,type}) => {
    const { t } = useTranslation();
    const [companyDataList,setCompanyDataList] = useState([]);

    useEffect(()=>{
        axios_queryCompaniesListByType();
    },[])

    const axios_queryCompaniesListByType= ()=>{
        queryCompaniesListByType({companyType:type})
            .then((res)=>{
                if(checkDpSuccess(res)){
                    setCompanyDataList(res?.data?.RespBody?.company?.options);
                }
            })
    }

  return (
    <div className="grid">
          <div className="col-12 lg:col-12">
                {/* 必填class required */}
                <label
                  htmlFor="relatedCompanySeq"
                  className="form-label required">
                  {t('organName')}
                </label>
                <Controller
                  name="relatedCompanySeq"
                  control={control}
                  rules={{ required: { value: true, message: t('validation.required') } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      optionLabel="label"
                      optionValue="value"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="relatedCompanySeq"
                      control={control}
                      options={companyDataList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "relatedCompanySeq")}
              </div>

    </div>
  )
}

export default AddCompany